import React, { useState } from 'react';
import './AdminPanel.css';
import StageTaskManager from './StageTaskManager';
import CompanyManagement from './CompanyManagement';
import AppSettings from './AppSettings';
import LevelSettings from './LevelSettings';

function AdminPanel({ user, onNavigate }) {
  const [activeTab, setActiveTab] = useState('tasks');

  const tabs = [
    { id: 'tasks', label: 'Manage Tasks', icon: '📋' },
    { id: 'company', label: 'Company Details', icon: '🏢' },
    { id: 'levels', label: 'Level Settings', icon: '🏆' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  return (
    <div className="admin-panel-container">
      <div className="admin-panel-header">
        <div className="header-content">
          <button className="back-btn" onClick={() => onNavigate('dashboard')}>
            ← Back to Dashboard
          </button>
          <h1>Admin Panel</h1>
        </div>
      </div>

      <div className="admin-panel-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="admin-panel-content">
        {activeTab === 'tasks' && <StageTaskManager user={user} />}
        {activeTab === 'company' && <CompanyManagement user={user} />}
        {activeTab === 'levels' && <LevelSettings />}
        {activeTab === 'settings' && <AppSettings />}
      </div>
    </div>
  );
}

export default AdminPanel;

